// extracted by mini-css-extract-plugin
export default {"collage-container":"Kitchen_collage-container__0hREe","collage-image":"Kitchen_collage-image__Ed36-","bar":"Kitchen_bar__m6ISL"};